export default __webpack_public_path__ + "static/media/Gitlab.ee0329ca.svg";